import { Component } from '@angular/core';
import { DocMeta } from "@template-ui/decorators";
import { UiLibraryModule } from "@template-ui/template-ui.module";


@DocMeta({
  showcaseTitle: "Simple panel header with just a title",
  hide: true
})
@Component({
    selector: 'ui-simple-panel-header.sample, ez-simple-panel-header.sample',
    imports: [UiLibraryModule],
    templateUrl: './SimplePanelHeaderSample.sample.html',
    styleUrl: './SimplePanelHeaderSample.sample.scss'
})
export class SimplePanelHeaderSample { }
